import EventTopic from "src/helpers/EventTopic";

const GlobalRefreshTopic = new EventTopic<{
	refresh: {
		props: {};
	};
}>();
export default GlobalRefreshTopic;
